import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import SearchPage from './components/SearchPage';
import RecommendedVideos from './components/RecommendedVideos';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';

function App() {
  return (
    // BEM class naming convention
    <div className="app">
      <Router>
      <Header/>
      <Switch>

        <Route path="/search/:searchTerm">
          <div className="app__page">
            <Sidebar/>
            <SearchPage/>
          </div>
        </Route>

        <Route>
          <div className="app__page">
            <Sidebar/>
            <RecommendedVideos/>
          </div>
        </Route>
        

        </Switch>
      </Router>
    </div>
  );
}

export default App;
